import { SearchProjects } from '@platform/client';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { CauseSelectionDropdown } from '../../components/CauseSelectionDropdown';
import { LanguageSelectionDropdown } from '../../components/LanguageSelectionDropdown';
import { PaginationBar } from '../../components/PaginationBar';
import { RoleTypeSelectionDropdown } from '../../components/RoleTypeSelectionDropdown';
import { SkillsSelectionDropdown } from '../../components/SkillsSelectionDropdown';
import { ProjectCard } from './ProjectCard';

const ProjectPageSize = 50;

export const ProjectCards = () => {
  const [sdgSelection, setSdgSelection] = useState<string[]>([]);
  const [languageSelection, setLanguageSelection] = useState<string[]>([]);
  const [skillsSelection, setSkillsSelection] = useState<string[]>([]);
  const [roleSelection, setRoleSelection] = useState<string[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const data = SearchProjects.useSearchProjects({
    causes: sdgSelection.join(';'),
    languages: languageSelection.join(';'),
    skills: skillsSelection.join(';'),
    roles: roleSelection.join(';'),
    page: currentPage,
    limit: ProjectPageSize,
  });
  const numProjects = data.data?.filteredCount || 0;
  const numPages = Math.ceil(numProjects / ProjectPageSize);

  const onPageSelect = (page: number) => {
    setCurrentPage(page - 1);
  };

  return (
    <div>
      <div className='flex flex-col md:flex-row md:gap-4 text-lg'>
        <div className='w-[350px] p-2'>
          <CauseSelectionDropdown
            selectedCauses={sdgSelection}
            onCausesSelectionChange={setSdgSelection}
            label='What causes would you like to contribute to?'
          />
        </div>
        <div className='w-[350px] p-2'>
          <LanguageSelectionDropdown
            selectedLanguages={languageSelection}
            onLanguageSelectionChange={setLanguageSelection}
            label='Which languages do you speak?'
          />
        </div>
        <div className='w-[350px] p-2'>
          <SkillsSelectionDropdown
            selectedSkills={skillsSelection}
            onSkillsSelectionChange={setSkillsSelection}
            label='What skills do you have?'
          />
        </div>
        <div className='w-[350px] p-2'>
          <RoleTypeSelectionDropdown
            selectedRoleType={roleSelection}
            onRoleTypeSelectionChange={setRoleSelection}
            label='What kind of support would you like to provide?'
          />
        </div>
      </div>
      {data.isSuccess && (
        <div className='grid grid-cols- md:grid-cols-3 bg-gray-50 gap-6 py-10 px-4'>
          {data.data.projects.map((project) => {
            return <ProjectCard project={project} key={project.id} />;
          })}
        </div>
      )}
      {!data.isSuccess && <Skeleton />}
      <PaginationBar
        numPages={numPages}
        currentPage={currentPage + 1}
        onPageSelect={onPageSelect}
      />
    </div>
  );
};
